import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section id="volumenes" className="border-b border-line bg-cream" data-id="element-271" data-mp="3utcdx1k8g6px">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-272" data-mp="cp0yyc53h08e">
        <div className="max-w-2xl" data-id="element-273" data-mp="cm526r4zghlj">
          <Eyebrow data-id="element-274" data-mp="7oweyc4z9ndf">El sistema completo: 6 volúmenes</Eyebrow>
          <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight text-ink sm:text-5xl" data-id="element-275" data-mp="7nldwk2x2tq0">
            Qué hay dentro de los seis volúmenes
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-276" data-mp="3c5h5zybaxn4q">
            Cada página es un PDF listo para imprimir, diseñado para enseñarse el mismo día — sin
            preparación, sin adaptaciones, sin adivinar.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-277" data-mp="2xdyh1b0gsi98">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-2xl border border-line bg-paper p-7 shadow-card" data-id="element-278" data-mp="2sfwxyq31gixr">
              <div className="flex items-baseline justify-between gap-4 border-b border-line pb-4" data-id="element-279" data-mp="29eh0mggnr3jc">
                <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-accent" data-id="element-280" data-mp="2edjvj82xbtdl">
                  Volumen {volume.number}
                </span>
                <span className="text-[11px] uppercase tracking-eyebrow text-ink-mute" data-id="element-281" data-mp="2o4er532285bp">
                  {volume.pages}
                </span>
              </div>

              <h3 className="mt-5 font-display text-2xl font-semibold leading-tight text-ink" data-id="element-282" data-mp="1qih5wxwaplw2">
                {volume.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-283" data-mp="20f2e1s3m3d44">
                {volume.description}
              </p>

              <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-284" data-mp="24h73sfqxvplh">
                {volume.tags.map(tag => <li key={tag} className="rounded-full bg-sand px-3 py-1 text-xs font-medium text-ink-soft" data-id="element-285" data-mp="3bsxrmwevbdt8">
                    {tag}
                  </li>)}
              </ul>
            </li>)}
        </ol>
      </div>
    </section>;
}